// Všechna obchodní data jsou PLACEHOLDERY. Před spuštěním nahraď hodnoty.
// TODO: doplnit skutečné údaje firmy.

export const BRAND = {
  // TODO
  name: "Podlahy Novák",
  // TODO
  owner: "Jan Novák",
  // TODO
  tagline: "Pokládka, renovace a lišty",
  // TODO
  locality: "Opava a okolí",
} as const;

export const CONTACT = {
  // TODO
  phone: "+420 123 458 682",
  phoneHref: "tel:+4200123458682",
  // TODO
  email: "novak@podlahy.cz",
  emailHref: "mailto:novak@podlahy.cz",
  // TODO
  openingHours: "Po–Pá 8:00–17:00",
  // TODO
  ico: "28163256",
} as const;

export const SITE = {
  // TODO
  url: "https://podlahynovak.cz",
  locale: "cs_CZ",
  lang: "cs",
} as const;

// TODO: vyplň endpoint (např. Formspree) — dokud je prázdný, formulář zobrazí
// poctivý ukázkový režim s mailto/tel (nikdy falešný úspěch).
export const FORM_ENDPOINT = "";

export const CTA = {
  label: "Poptat pokládku podlahy",
  href: "#kontakt",
  shortLabel: "Poptat pokládku",
} as const;
